import type { InvestorNetWorthChange } from '@/interfaces/netWorthChanges';
import { formatNumberToCurrency } from '@/utils/currency';
import { hasUndefinedPercentChange } from './rankNetWorthChanges';

/** Keys the footer row. No InvestorId is negative, so it cannot collide. */
export const TOTAL_ROW_ID = -1;

/** Whether a row is the pinned footer rather than a client. */
export function isTotalRow(row: InvestorNetWorthChange): boolean {
  return row.Id === TOTAL_ROW_ID;
}

/**
 * The row's dollar change as currency. As in legacy, a gain carries no `+`:
 * its colour says which way it went, and a fall keeps its `-`.
 */
export function formatDollarChange(row: InvestorNetWorthChange): string {
  return formatNumberToCurrency(row.DollarChange);
}

/**
 * The row's percentage, unsigned for a gain as in legacy, or null when it
 * started the period at zero and has no percentage to show.
 */
export function formatPercentChange(
  row: InvestorNetWorthChange,
): string | null {
  if (hasUndefinedPercentChange(row)) return null;
  return `${row.PercentChange.toFixed(2)}%`;
}

/**
 * What the % Change column sorts on. A $0 start has only the API's stand-in
 * 100, so it sorts as no value -- below every real percentage -- rather than
 * as a 100% move ahead of genuine ones.
 */
export function sortablePercentChange(
  row: InvestorNetWorthChange,
): number | null {
  if (hasUndefinedPercentChange(row)) return null;
  return row.PercentChange;
}
